import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from 'react-apollo';
import ApolloPublicInstance from '../../apollo/setupClientePagamento';
import VerificarAcesso from './components/verificarAcesso';
import Checkout from './components/checkout';
import PagamentoSucesso from './components/pagamentoSucesso';
import { GET_PROFISSIONAL_SAUDE_CLIENTE_PAGAMENTO_ID, GET_VALOR } from '../../graphql/queryes';

const PagamentoIaProfissional = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idProfissional = searchParams.get('idProfissional');

  const [verificarAcesso, setVerificarAcesso] = useState(false);
  const [showPagamentoSucesso, setShowPagamentoSucesso] = useState(false);
  const [responsavelCpf, setResponsavelCpf] = useState('14661945298');
  const [dadosProfissional, setDadosProfissional] = useState({
    id: '',
    valor: '',
    profissional: {
      cpf: '',
      nome: '',
    },
  });

  const [loadProfissionalData, { data: dadosProfissionalPagamento }] =
    useLazyQuery(GET_PROFISSIONAL_SAUDE_CLIENTE_PAGAMENTO_ID);

  const [loadValor, { data }] = useLazyQuery(GET_VALOR);

  const handleIrAoCheckout = () => {
    setVerificarAcesso(true);
  };

  const handlePagamentoSucesso = () => {
    setShowPagamentoSucesso(true);
  };

  const atualizarDados = (dadosAtualizados, loginCpf) => {
    setResponsavelCpf(loginCpf);
    setDadosProfissional({
      ...dadosProfissional,
      ...dadosAtualizados,
    });
  };

  useEffect(() => {
    if (idProfissional) {
      loadProfissionalData({
        variables: {
          profissionalSaudeId: parseInt(idProfissional),
          cpf: null,
        },
      });
      loadValor()
      setVerificarAcesso(true);
    }
  }, [idProfissional, loadProfissionalData,loadValor]);

  useEffect(() => {
    if (dadosProfissionalPagamento?.findDadosProfissionalSaude) {
      const dados = dadosProfissionalPagamento?.findDadosProfissionalSaude;
      const profissional = {
        nome: dados?.nome,
        cpf: dados?.cpf,
        telefone: dados?.usuario?.telefone,
        endereco: dados?.endereco,
        email: dados?.email
      }

      setDadosProfissional(
        profissional
      );
    }
  }, [dadosProfissionalPagamento]);

  return (
    <Content>
      {showPagamentoSucesso ? (
        <PagamentoSucesso responsavelCpf={responsavelCpf} />
      ) : !verificarAcesso ? (
        <VerificarAcesso
          handleIrAoCheckout={handleIrAoCheckout}
          handleAtualizarDados={atualizarDados}
        />
      ) : (
        <Checkout
          dadosProfissional={dadosProfissional}
          handlePagamentoSucesso={handlePagamentoSucesso}
          valor={data?.findValorPagamentoId}
        />
      )}
    </Content>
  );
};

const HocApolloInstance = (Component) => () =>
  (
    <ApolloPublicInstance>
      <Component />
    </ApolloPublicInstance>
  );

const Content = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
`;

export default HocApolloInstance(PagamentoIaProfissional);
